<template>
    <div class="root">
        <slot />
    </div>
</template>

<style scoped lang="scss">
@include scroll-fantasy;
.root {
    overflow-x: hidden;
    :deep() {
        strong {
            @include font-weight(bold);
        }

        li {
            display: list-item;
        }

        a,
        blockquote,
        q,
        abbr,
        address,
        cite,
        bdo,
        h1,
        h2,
        h3,
        h4 {
            all: revert;
        }

        ol {
            display: block;
            list-style: decimal;
            margin: 1em 0;
            padding-right: 40px;
        }

        ul {
            display: block;
            list-style: disc;
            margin: 1em 0;
            padding-right: 40px;
        }

        .content {
            max-width: 100%;
        }

        .table {
            overflow-x: auto;
            border: 1px solid usePalette($p-blue, $p-100) !important;
            border-radius: 24px;
            margin: 0 !important;
            padding: 16px;
            background-color: white;
            @include scroll-fantasy;
            table {
                p {
                    margin: 0;
                }
                border-collapse: collapse !important;
                border-spacing: 0 !important;
                border: none !important;
                .header,
                .data {
                    white-space: nowrap;
                }
                overflow-y: auto;
                max-height: 100%;
                width: 100%;
                tr {
                    border-collapse: collapse !important;
                    border-spacing: 0 !important;
                    &:not(:last-child) {
                        border-bottom: 1px solid usePalette($p-blue, $p-100);
                    }
                    &:last-child td {
                        padding-bottom: 4px !important;
                    }
                    th {
                        & * {
                            @include tg-xl(
                                $w7,
                                usePalette($p-gray, $p-900),
                                true
                            );
                            text-align: center !important;
                        }
                        border-collapse: collapse !important;
                        border-spacing: 0 !important;
                        white-space: nowrap;
                        border: none !important;
                        height: 48px !important;
                        &:first-child {
                            border-radius: 0 16px 16px 0;
                        }

                        &:last-child {
                            border-radius: 16px 0 0 16px;
                        }

                        padding: 8px !important;
                        background-color: usePalette(
                            $p-cool-gray,
                            $p-200
                        ) !important;
                    }
                    td {
                        border-collapse: collapse !important;
                        border-spacing: 0 !important;
                        border: none !important;
                        white-space: nowrap;
                        padding: 20px 8px !important;
                        @include tg-m($w5, usePalette($p-blue, $p-700));
                    }
                }
            }
        }
    }
}
</style>
